'use strict';

var borderRadii = require('../../../../../../../../_virtual/borderRadii.cjs');

const AviaryBorderRadii = {
    small: "small",
    medium: "medium",
    circular: "circular"
};

borderRadii.__exports.AviaryBorderRadii = AviaryBorderRadii;

module.exports = borderRadii.__exports;
//# sourceMappingURL=borderRadii.cjs.map
